import { render, staticRenderFns } from "./InventoryManage.vue?vue&type=template&id=4f51d2d4&scoped=true&"
import script from "./InventoryManage.vue?vue&type=script&lang=js&"
export * from "./InventoryManage.vue?vue&type=script&lang=js&"
import style0 from "./InventoryManage.vue?vue&type=style&index=0&id=4f51d2d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f51d2d4",
  null
  
)

export default component.exports